/**
 * An action config containing properties for primary and secondary actions such as
 * multiple buttons and kebab menu options
 */
var ActionConfig = /** @class */ (function () {
    function ActionConfig() {
    }
    return ActionConfig;
}());
export { ActionConfig };
//# sourceMappingURL=action-config.js.map